import React from 'react';
import './DeviceStatus.css'
import moment from 'moment';
import FontIcon from 'material-ui/FontIcon';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';
import safeIcon from '../../img/safe.svg';
import numeral from 'numeral';
import translate from '../../lib/i18n/translate'


export const DeviceStatus = ({device, strings}) => {
    
    const {AllOk} = strings;

    const DeviceStatusHeader = ({device})=>(
        <Grid fluid className={`${device.deviceStatus} DeviceStatusHeader`}>
            <Row middle="xs">
                <Col xs={6} sm={6} md={4} lg={4}>
                    <img src={safeIcon} alt="Safe icon" className="safeIcon"/>
                    <div className="DeviceName">{device.deviceName}</div>
                </Col>
                <Col xs={6} sm={6} md={8} lg={8} style={{textAlign: 'right'}}>
                    {(device.balances || []).map((b,i) =>
                        <div key={i}>{numeral(b.amount/100).format('0,0.00')} {b.currency}</div>
                    )}
                </Col>
            </Row>
        </Grid>
    );

    const DeviceProblem = ({problem})=>(
        <Row>
            <Col xs={6} sm={6} md={6} lg={6}>
                <FontIcon className="material-icons left">error</FontIcon>
                <div className="StatusText">{problem.deviceProblem}</div>
            </Col>
            <Col xs={6} sm={6} md={6} lg={6} style={{textAlign: 'right'}}>
                <span title={moment(problem.deviceProblemDate).format("YYYY-MM-DD HH:mm")}>
                    {moment(problem.deviceProblemDate).format("YYYY-MM-DD HH:mm")}
                </span>
            </Col>
        </Row>
    );
    
    const AllOkSection = (
        <div>
            <FontIcon className="material-icons left OkIcon">verified_user</FontIcon>
            <div className="StatusText">{AllOk}</div>
        </div>
    );


    return (
        <Col xs={12} sm={12} md={6} lg={6}>
        <Paper className="Device" zDepth={0}>
            <DeviceStatusHeader device={device}/>
            <Grid fluid style={{padding:0}}>

            {(device.warnings || []).map((p,i) =>
                    <DeviceProblem problem={p}  key={i}/>
                )
            }
            {device.warnings.length===0 && AllOkSection}
            </Grid>
        </Paper>
        </Col>

    );
};

export default translate('DeviceStatus')(DeviceStatus);




// WEBPACK FOOTER //
// ./src/components/deviceStatus/DeviceStatus.js